import {
    ReleaseNoteHighlight,
    ReleaseNoteTourStepView,
    ReleaseNoteVersion,
} from './release-notes';

export function buildReleaseNoteTourSteps(versions: ReleaseNoteVersion[]): ReleaseNoteTourStepView[] {
    const steps: ReleaseNoteTourStepView[] = [];

    for (const version of versions) {
        for (const highlight of version.highlights ?? []) {
            steps.push(...buildStepsForHighlight(version, highlight));
        }
    }

    steps.forEach((step, index) => {
        step.globalStepNumber = index + 1;
        step.globalTotalSteps = steps.length;
    });

    return steps;
}

function buildStepsForHighlight(
    version: ReleaseNoteVersion,
    highlight: ReleaseNoteHighlight,
): ReleaseNoteTourStepView[] {
    const kundenportalOnly =
        highlight.apps?.includes('kundenportal') && !highlight.apps?.includes('desktop');
    const sectionIntro = highlight.title?.startsWith('Weiter mit:') ?? false;

    if (highlight.steps?.length) {
        return highlight.steps.map((step, index) => ({
            featureTitle: highlight.title,
            version: version.version,
            versionDate: version.date,
            stepNumber: index + 1,
            totalStepsInFeature: highlight.steps.length,
            globalStepNumber: 0,
            globalTotalSteps: 0,
            title: step.title,
            description: step.description,
            image: step.image ?? highlight.image,
            video: step.video ?? highlight.video,
            route: step.route,
            kundenportalOnly,
            sectionIntro,
        }));
    }

    return [
        {
            featureTitle: highlight.title,
            version: version.version,
            versionDate: version.date,
            stepNumber: 1,
            totalStepsInFeature: 1,
            globalStepNumber: 0,
            globalTotalSteps: 0,
            title: highlight.title,
            description: highlight.description ?? '',
            image: highlight.image,
            video: highlight.video,
            kundenportalOnly,
            sectionIntro,
        },
    ];
}

export function getReleaseNoteFeatureKey(step: ReleaseNoteTourStepView): string {
    return `${step.version}::${step.featureTitle}`;
}
